export default function IndustryFocus() {
  return (
    <section className="industry-focus" id="industries">
      <div className="container">
        <div className="section-title">
          <h2>Designed for Your Industry</h2>
          <p>We understand the unique needs of businesses in the {/* Palghar-Boisar */} industrial belt</p>
        </div>

        <div className="industry-grid">

          {[
            { icon: "⚗️", title: "Chemical & Pharma", desc: "Showcase your products with secure, professional digital presence" },
            { icon: "⚙️", title: "Engineering & Manufacturing", desc: "Display your capabilities and parts catalog to global clients" },
            { icon: "📦", title: "Packaging", desc: "Highlight your product range and material specifications" },
            { icon: "🔧", title: "Auto Ancillaries", desc: "Connect with OEMs and showcase your component expertise" }
          ].map((item, i) => (
            <div className="industry-card" key={i}>
              <div className="industry-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
